import React from 'react';
import { ArrowDownIcon, ArrowRightIcon } from 'lucide-react';
import { IMAGES } from '../data/site';
import { QuoteForm } from './QuoteForm';
const HERO_ALT = 'Concept image of two Kosin’s Glass service vans at a commercial building, one with its cargo door open';
export function Hero() {
  return <section aria-labelledby="hero-heading" className="relative isolate w-full bg-kosin-mist lg:bg-kosin-charcoal" data-id="element-148" data-mp="4mi297ij3icw">
      <picture data-id="element-149" data-mp="128z0cez35zzp">
        <source media="(min-width: 1024px)" srcSet={IMAGES.heroWide} width={2172} height={724} data-id="element-150" data-mp="127edzcmxdncx" />
        <img src={IMAGES.heroMobile} alt={HERO_ALT} width={1086} height={1448} className="absolute inset-x-0 top-0 h-[600px] w-full object-cover object-bottom sm:h-[720px] lg:h-full lg:object-left-bottom" data-id="element-151" data-mp="sai4b3laiv6s" />
      </picture>
      <div aria-hidden="true" className="absolute inset-x-0 top-0 h-[335px] bg-black/65 sm:h-[300px] lg:hidden" data-id="element-152" data-mp="382p5xe0y1flo" />

      <div className="relative mx-auto max-w-shell px-[18px] sm:px-6 lg:grid lg:min-h-[620px] lg:grid-cols-[minmax(0,1fr)_400px] lg:items-start lg:gap-9 lg:py-6" data-id="element-153" data-mp="3j7zhzqi0g6kd">
        <div className="min-h-[600px] pt-6 sm:min-h-[720px] sm:pt-8 lg:min-h-0 lg:pt-0" data-id="element-154" data-mp="3o59e1ozwngh6">
          <p className="flex items-center gap-3 text-[16px] font-bold text-kosin-ondark" data-id="element-155" data-mp="39cfmh57cz9w5">
            <span className="h-[3px] w-8 shrink-0 bg-kosin-ondark" aria-hidden="true" data-id="element-156" data-mp="3e7l780p0yiin" />
            Kosin’s Glass
          </p>

          <h1 id="hero-heading" className="mt-2 max-w-[700px] text-[30px] font-bold leading-[1.1] text-white sm:text-[38px] xl:text-[44px] [text-shadow:0_1px_12px_rgba(0,0,0,0.6)]" data-id="element-157" data-mp="359szpipjof5t">
            Glass Repair, Replacement &amp; Custom Glass
          </h1>

          <p className="mt-3 max-w-[560px] text-[16px] leading-[1.5] text-white sm:text-[17px] [text-shadow:0_1px_12px_rgba(0,0,0,0.6)]" data-id="element-158" data-mp="2hix2g62bkrr6">
            Family-owned since 2000, serving Southeast Michigan’s vehicles,
            homes and businesses.
          </p>

          <p className="mt-3 text-[14px] leading-5 text-white sm:text-[15px] [text-shadow:0_1px_12px_rgba(0,0,0,0.6)]" data-id="element-159" data-mp="s3undmopqq5v">
            <span className="block font-semibold sm:inline" data-id="element-160" data-mp="ibozao1l0svy">Three Convenient Locations</span>
            <span className="mx-2 hidden text-white/60 sm:inline" aria-hidden="true" data-id="element-161" data-mp="ddf4wfnolwbe">
              |
            </span>
            Howell • Ann Arbor • Novi
          </p>

          <div className="mt-3 flex flex-wrap gap-x-6 gap-y-2 text-[14px] font-semibold text-white" data-id="element-162" data-mp="1ayt5uxgbpf9u">
            <a href="#hero-quote" className="focus-light inline-flex min-h-8 items-center gap-2 underline underline-offset-4 lg:hidden" data-id="element-163" data-mp="15zzv3csf82dd">
              Get A Free Quote
              <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-164" data-mp="3lsyrwwxreii0" />
            </a>
            <a href="#services" className="focus-light inline-flex min-h-8 items-center gap-2 underline underline-offset-4" data-id="element-165" data-mp="3lquhrx99on9a">
              Explore Our Services
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-166" data-mp="1x7hub9ezzuyr" />
            </a>
          </div>
        </div>

        <div id="hero-quote" className="pb-8 pt-5 lg:w-[400px] lg:justify-self-end lg:py-0" data-id="element-167" data-mp="269zfdkix2hk6">
          <QuoteForm idPrefix="hero" data-id="element-168" data-mp="2b0plx132wqgg" />
        </div>
      </div>
    </section>;
}